import { connect } from 'formik'

const FormError = ({ formik: { errors }, name, children, className }) =>
  name && errors[name] ? children({ message: errors[name] }) : null

export default connect(FormError)
